"use client";

import { useTheme } from "@mui/material";

import MDTypography from "@/components/atoms/MDTypography";

type TermsSectionProps = {
  title?: string;
  description: string[] | string;
  firstItemAsText?: boolean;
  lastItemAsText?: boolean;
  allItemsAsText?: boolean;
};

export const TermsSection: React.FC<TermsSectionProps> = ({
  title,
  description,
  firstItemAsText = false,
  lastItemAsText = false,
  allItemsAsText = false,
}) => {
  const {
    margins: { quarck },
  } = useTheme();

  const renderDescription = () => {
    if (Array.isArray(description) && description.length) {
      if (allItemsAsText) {
        return description.map((item, index) => (
          <MDTypography
            key={`text-${index}`}
            variant="body2"
            color={"text"}
            sx={{ marginBottom: quarck - 1 }}
          >
            {item}
          </MDTypography>
        ));
      }

      const firstItem = firstItemAsText ? [description[0]] : [];
      const lastItem = lastItemAsText ? [description[description.length - 1]] : [];
      let itemsToRender = description;
      if (firstItemAsText) itemsToRender = itemsToRender.slice(1);
      if (lastItemAsText) itemsToRender = itemsToRender.slice(0, -1);

      return (
        <>
          {firstItem.map((item, index) => (
            <MDTypography
              key={`first-${index}`}
              variant="body2"
              color={"text"}
              sx={{ marginBottom: quarck - 1 }}
            >
              {item}
            </MDTypography>
          ))}
          <ul>
            {itemsToRender.map((item, index) => (
              <li key={index}>
                <MDTypography variant="body2" color={"text"} sx={{ marginBottom: quarck - 1 }}>
                  {item}
                </MDTypography>
              </li>
            ))}
          </ul>
          {lastItem.map((item, index) => (
            <MDTypography
              key={`last-${index}`}
              variant="body2"
              color={"text"}
              sx={{ marginBottom: quarck - 1 }}
            >
              {item}
            </MDTypography>
          ))}
        </>
      );
    } else if (typeof description === "string") {
      return (
        <>
          <MDTypography variant="body2" color={"text"} sx={{ marginBottom: quarck - 1 }}>
            {description}
          </MDTypography>
        </>
      );
    }
  };

  return (
    <>
      {title && (
        <MDTypography component={"p"} variant="button" fontWeight="bold" mb={3}>
          {title}
        </MDTypography>
      )}
      {renderDescription()}
    </>
  );
};
